import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from '@mui/material/Modal';
import Spinner from 'react-bootstrap/Spinner'
import { ToastContainer } from 'react-toastify';
import { ObjModal } from '../../contexts';
import YoYFlows from '../../components/Home/YoYFlows';
import ActiveLoans from '../../components/Home/ActiveLoans';
import Work from '../../components/Home/Work';
import Jeopardy from '../../components/Home/Jeopardy';
import Queues from '../../components/Home/Queues';
import Rates from '../../components/Home/Rates';


const Home = ( { aid, uid, acctElements, userElements } ) => {
    const options = {
        yoyflows: YoYFlows,
        activeloans: ActiveLoans,
        work: Work,
        jeopardy: Jeopardy,
        paprogress: Queues,
        queue: Queues,
        rates: Rates
    };

    const [ elements, setElements ] = useState( [] );
    const [ processing, setProcessing ] = useState( true );
    const [ modal, setModal ] = useState();
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);

    useEffect( () => {
        if ( userElements?.meta?.home?.details?.length ) {
            setElements( userElements.meta.home.details );
            setProcessing( false );
        } else if ( acctElements.length ) {
            setElements( acctElements );
            setProcessing( false );
        }
    }, [ acctElements, userElements ] );

    useEffect( () => {
        document.title = 'Third Floor - Home';
    }, [] );

    return (
        <Container fluid className='p-0'>
            <ObjModal.Provider value={ { openModal, closeModal, setModal } }>
            {
                !processing ? (
                    elements.map( ( e, idx ) => {
                        const C = options[e.comp];
                        const subs = ( e.subcomps && e.subcomps.length ) ? e.subcomps : [];

                        return (
                            <Row className='tf-section-container p-0 mt-2' key={idx}>
                                <Col className='p-0'>
                                    <C title={e.title} subs={subs} e={e} />
                                </Col>
                            </Row>
                        )
                    } )
                ) : (
                    <Row className='py-3'>
                        <Col className='text-center'>
                            <Spinner animation="border" variant='primary' role="status" />
                        </Col>
                    </Row>
                )
            }
            </ObjModal.Provider>
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
            <ToastContainer autoClose={3000} />
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    acctElements: state.user.meta.home.details,
    userElements: state.user.crm
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Home );